import { IOrder } from '../../../types/store';
import { objectIsEmpty } from '../../../../shared/utils/objectHelper';

export const isEmptyDDoSProtection = (order: IOrder): boolean => order.ddosProtection ? objectIsEmpty(order.ddosProtection) : true;
